import { ListGroup } from 'react-bootstrap';
import styled from 'styled-components';
import styles from '../edits/styles.json';
import { trackClick } from '../lib/tracking';

const { enlaces } = styles;

const colorFondo = enlaces.colorFondo;
const colorTexto = enlaces.colorTexto;
const colorHover = enlaces.colorHover;
const borderRadius = enlaces.borderRadius;
const borderColor = enlaces.borderColor;
const colorIcon = enlaces.colorIcon;
const fontSize = enlaces.fontSize;
const fontWeigth = enlaces.fontWeigth;
const textTransform = enlaces.textTransform;
const scaleLink = enlaces.scaleLink;
const margin = enlaces.margin;
const padding = enlaces.padding;


const EnlacesListItem = styled.li
`
	display: flex;
	align-items: center;
	width: 100%;
`;

const Enlace = styled.a`
	flex-grow: 1;
	width: 25vw;
	padding: ${padding};
	margin: ${margin};
	background-color: ${colorFondo};
	color: ${colorTexto};
	font-weight: ${fontWeigth};
	text-align: center;
	text-decoration: none;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${borderRadius};
	border: 1px solid ${borderColor};
	text-transform: ${textTransform};
	transform: scale(1);
  	transition: transform 0.3s ease;
	position: relative;

	&:hover {
		background-color: ${colorHover};
		transform: ${scaleLink};	
	}

	@media (max-width: 768px) {
		width: 60vw;
	}
`;

// const Icono = styled(FontAwesomeIcon)`
// 	margin-right: 10px;
// 	// flex-shrink: 0;
// 	color: ${colorIcon};
// 	font-size: ${fontSize};

// 	&.icon-delete {
// 		color: rgba(255, 0, 0, 0);
// 	}
// `;

const Img = styled.img`
	height: 32px;
	position: absolute;
	left: 16px;
`;

function generateLi(links) {
    return (
      <>
        {links.filter(link => link.render === 'si').map((link, index) => (
          <EnlacesListItem key={index}>
						<Enlace href={link.url} target="_blank" onClick={() => trackClick(index)}>
							<Img src="pedidos-ya-logo.png" alt="logo" />
              {link.nombre}
            </Enlace>
          </EnlacesListItem>
        ))}
      </>
    );
  }
  
  function Enlaces({ links }) {
    return (
      <ListGroup>
        {generateLi(links)}
      </ListGroup>
    );
  }

export default Enlaces;
